/* Brand wordmark — lowercase Bricolage extrabold with the orange
 * terminal dot ("punctul viu"): the dot scales up on hover behind
 * motion-safe, a two-line heartbeat that makes the brand feel alive.
 *
 * Size comes from the caller via className (text-xl, text-3xl…) so the
 * same component fits navbars, auth shells and footers. `onInk` flips
 * to the cream/primary-400 scale for dark surfaces — the dot steps up
 * a stop because primary-500 loses presence on ink.
 */
export default function Wordmark({ onInk = false, className = '' }) {
  return (
    <span
      className={`group/wm select-none font-display font-extrabold tracking-tight ${
        onInk ? 'text-cream-50' : 'text-ink'
      } ${className}`}
    >
      petzy
      <span
        className={`inline-block motion-safe:transition-transform motion-safe:duration-300 motion-safe:group-hover/wm:scale-150 ${
          onInk ? 'text-primary-400' : 'text-primary-500'
        }`}
      >
        .
      </span>
    </span>
  );
}
